import chunk from 'lodash/chunk';

export const chunkElementForms = (elements, chunkSize) => chunk(elements, chunkSize).map(chunks => chunk(chunks, chunkSize / 3))
